import contentfulGql from 'js/lib/contentfulGql';

export const entWebsiteDividerFragment = contentfulGql`#graphql
  fragment EntWebsiteDivider on EntWebsiteDivider {
    height
    marginTop
    marginBottom
  }
`;
